import React from 'react'
import type { DropdownMenuEvent, DropdownMenuItem } from 'sutra/components'
import { DropdownMenu } from 'sutra/components'
import { KebabButton } from 'sutra/components/KebabButton/KebabButton'

import { MoreVert } from 'features/ask-yogi/components/icons'
import { KebabSlot } from 'features/ask-yogi/features/conversation/components/VerbatimCard/verbatim-card.styles'

export interface VerbatimCardMenuProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  showFullRecord: boolean
  onToggleFullRecord: () => void
  /** Omitted (undefined) when the citation has no linkable record — hides
   *  the "View in Feedback" item entirely rather than showing it disabled. */
  onViewFullRecord?: () => void
  onCopyImage: () => void
}

// Same shape as feedback's VerbatimCardMenu (a kebab + DropdownMenu driving
// a fixed action set) for this card's own action set — not reused directly
// across features since the actions differ and it would be a cross-feature
// private import either way.
export const VerbatimCardMenu: React.FC<VerbatimCardMenuProps> = ({
  open,
  onOpenChange,
  showFullRecord,
  onToggleFullRecord,
  onViewFullRecord,
  onCopyImage,
}) => {
  const items: DropdownMenuItem[] = [
    {
      key: 'toggle-full-record',
      label: showFullRecord ? 'Hide full record' : 'Show full record',
    },
    ...(onViewFullRecord
      ? [{ key: 'view-full-record', label: 'View in Feedback' }]
      : []),
    { key: 'copy-image', label: 'Copy as image' },
  ]

  const handleAction = (key: string, event: DropdownMenuEvent): void => {
    event.stopPropagation()
    switch (key) {
      case 'toggle-full-record':
        onToggleFullRecord()
        break
      case 'view-full-record':
        onViewFullRecord?.()
        break
      case 'copy-image':
        onCopyImage()
        break
    }
  }

  return (
    <KebabSlot
      data-html2canvas-ignore="true"
      onClick={(e) => e.stopPropagation()}
    >
      <DropdownMenu
        side="bottom"
        align="end"
        open={open}
        onOpenChange={onOpenChange}
        items={items}
        onAction={handleAction}
      >
        <KebabButton size="sm" aria-label="Verbatim actions">
          <MoreVert fontSize="small" />
        </KebabButton>
      </DropdownMenu>
    </KebabSlot>
  )
}
